<template>
  <v-menu
    v-if="hasAnyItemsInMenu && asset"
    v-model="showingMenu"
    v-bind:target="[positionX, positionY]"
    :close-on-content-click="false"
    :persistent="false"
    absolute
    location="bottom"
  >
    <template v-slot:activator="{ props }">
      <slot v-bind="{ props }" name="activator" />
    </template>

    <v-list data-cy="podFiles-tree-actions-list">

      <v-list-item v-if="canShowViewAsset" @click="showViewAssetDialog()">
        <template v-slot:prepend>
          <v-icon size="small">mdi-play-box-outline</v-icon>
        </template>
        <v-list-item-title>{{ $t('routes.pod.viewAsset') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="canShowDownloadAssetItem"
        @click="downloadFile(asset)"
        data-cy="podFiles-tree-actions-downloadAsset"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-download-box-outline</v-icon>
        </template>
        <v-list-item-title>{{ $t('routes.pod.downloadAsset') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="canShowDeleteDialog"
        @click="showDeletePodDialog"
        data-cy="podFiles-tree-actions-deleteAsset"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-trash-can-outline</v-icon>
        </template>
        <v-list-item-title>{{ $t('routes.pod.deleteAsset') }}</v-list-item-title>
      </v-list-item>

    </v-list>
  </v-menu>

  <ViewAssetDialog
    v-if="canShowViewAsset"
    v-model="showingViewAssetDialog"
    :pod="pod"
    :asset="asset"
  />

  <DeletePodDialog
    v-if="canShowDeleteDialog"
    v-model="showingDeletePodDialog"
    :pod="pod"
    :asset="asset"
  />
</template>

<script>
import { useCommonStore } from '@/stores/CommonStore.js';
import ViewAssetDialog from '@/routes/pods2/components/dialogs/ViewAssetDialog.vue';
import DeletePodDialog from '../../../../../routes/nodes2/components/dialogs/DeletePodDialog.vue'

export default {
  emits: ["update:modelValue"],
  name: "LegalContextMenu",
  components: {
    DeletePodDialog,
    ViewAssetDialog,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    pod: {
      type: Object,
      required: true,
    },
    asset: {
      type: Object,
    },
    positionX: {
      type: Number,
      required: true,
    },
    positionY: {
      type: Number,
      required: true,
    },
  },
  data: function() {
    return {
      showingDeletePodDialog: false,
      showingViewAssetDialog: false,
    };
  },
  methods: {
    downloadFile: function (asset) {
      if (this.pod.archived) return;
      this.showingMenu = false;
      window.location = asset.url;
    },
    stub: function () {
      this.showingMenu = false;
    },
    showViewAssetDialog() {
      this.showingViewAssetDialog = true;
      this.showingMenu = false;
    },
    showDeletePodDialog: function () {
      this.showingDeletePodDialog = true;
      this.showingMenu = false;
    },
  },
  computed: {
    showingMenu: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    hasAnyItemsInMenu: function() {
      return this.$canControlNodeAndPod() ||
              this.$canDownloadNodeAndPod();
    },
    canShowViewAsset() {
      return true;
    },
    canShowDownloadAssetItem: function() {
      return !this.$isAdobeExtension() && !this.$isFCPExtension() && this.$canDownloadNodeAndPod() && this.isAssetCompleted;
    },
    canShowDeleteDialog: function() {
      return this.$canDeleteNodeAndPod();
    },
    isAssetCompleted: function() {
      return this.asset.state === this.assetStates.COMPLETE;
    },
    assetStates: function() {
      const commonStore = useCommonStore();
      return commonStore.assetStates;
    },
  },
}
</script>

<style>
</style>
